var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressIcon__container",class:_vm.background[_vm.status],style:(_vm.sizeRelatedStyle[_vm.size])},[(_vm.status === _vm.TOPIC_STATUS.COMPLETED || _vm.status === _vm.TOPIC_STATUS.MASTERED)?_c('font-awesome-icon',{attrs:{"icon":_vm.statusIcons[_vm.status],"size":_vm.size}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }